import { Position } from "geojson";

import { GaiaMapMarkerFieldworkerDroppable } from "~/modules/plannerV2/components/GaiaMapMarkerFieldworkerIcon/GaiaMapMarkerFieldworkerDroppable";
import { GaiaMapMarkerFieldworkerLoading } from "~/modules/plannerV2/components/GaiaMapMarkerFieldworkerIcon/GaiaMapMarkerFieldworkerLoading";

interface PickupActionLoadingGhostProps {
    coordinates: Position;
    actionType: "move" | "merge" | null;
}

export function PickupActionLoadingGhost({ coordinates, actionType }: PickupActionLoadingGhostProps) {
    if (actionType === "move") {
        return <GaiaMapMarkerFieldworkerLoading coordinates={coordinates} />;
    }

    if (actionType === "merge") {
        return <GaiaMapMarkerFieldworkerDroppable coordinates={coordinates} loading={true} />;
    }

    return null;
}
